export class InteractionAd {
    static merge(to: InteractionAd, from: InteractionAd) {
        const accumulate = (fieldName: string) => {
            if (from[fieldName]) {
                to[fieldName] = (!to[fieldName] ? 0 : to[fieldName]) + from[fieldName];
            }
        };
        accumulate("pgViewCount");
        accumulate("pgViewTime");
        accumulate("pgVideoCount");
        accumulate("pgVideoTime");
        accumulate("pgThanksCount");
        accumulate("pgThanksTime");
        accumulate("pgSponsorCount");
        accumulate("pgSponsorTime");
        accumulate("tapWebsiteCount");
        accumulate("tapAdCount");
        accumulate("tapDirectionsCount");
    }

    pgViewCount?: number;
    pgViewTime?: number;
    pgVideoCount?: number;
    pgVideoTime?: number;
    pgThanksCount?: number;
    pgThanksTime?: number;
    pgSponsorCount?: number;
    pgSponsorTime?: number;

    tapWebsiteCount?: number;
    tapAdCount?: number;
    tapDirectionsCount?: number;
}
